/**
 * 네이버 지도 SDK 동적 로더 — 싱글턴
 */

import { useState, useEffect } from 'react'

let sdkPromise: Promise<void> | null = null

function loadSDK(clientId: string): Promise<void> {
  if (sdkPromise) return sdkPromise

  sdkPromise = new Promise<void>((resolve, reject) => {
    if (window.naver?.maps) {
      resolve()
      return
    }

    const script = document.createElement('script')
    script.src = `https://oapi.map.naver.com/openapi/v3/maps.js?ncpKeyId=${clientId}&submodules=geocoder`
    script.async = true
    script.onload = () => resolve()
    script.onerror = () => {
      sdkPromise = null
      reject(new Error('네이버 지도 SDK 로드 실패'))
    }
    document.head.appendChild(script)
  })

  return sdkPromise
}

export function useNaverMapSDK() {
  const [isLoaded, setIsLoaded] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const clientId = import.meta.env.VITE_NAVER_MAP_CLIENT_ID as string | undefined
    if (!clientId) {
      setError('VITE_NAVER_MAP_CLIENT_ID가 설정되지 않았습니다')
      return
    }

    loadSDK(clientId)
      .then(() => setIsLoaded(true))
      .catch((err: Error) => setError(err.message))
  }, [])

  return { isLoaded, error }
}
